 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import COMONLOVE_1 from '@/components/Comon/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK1TEXTCOVER from '@/components/Book1/Text/cover'
 import BOOK1TEXTTITLEPAGE from '@/components/Book1/Text/titlepage'
 import BOOK1TEXTDEDICATION from '@/components/Book1/Text/dedication'
 import BOOK1TEXTAUTHORNOTE from '@/components/Book1/Text/authornote'
 import BOOK1TEXTQUOTES from '@/components/Book1/Text/quotes'
 import BOOK1TEXTSECTION0001 from '@/components/Book1/Text/Section0001'
 import BOOK1TEXTSECTION0002 from '@/components/Book1/Text/Section0002'
 import BOOK1TEXTSECTION0003 from '@/components/Book1/Text/Section0003'
 import BOOK1TEXTSECTION0004 from '@/components/Book1/Text/Section0004'
 import BOOK1TEXTSECTION0005 from '@/components/Book1/Text/Section0005'
 import BOOK1TEXTSECTION0006 from '@/components/Book1/Text/Section0006'
 import BOOK1TEXTSECTION0007 from '@/components/Book1/Text/Section0007'
 import BOOK1TEXTSECTION0008 from '@/components/Book1/Text/Section0008'
 import BOOK1TEXTSECTION0009 from '@/components/Book1/Text/Section0009'
 import BOOK1TEXTSECTION0010 from '@/components/Book1/Text/Section0010'
 import BOOK1TEXTSECTION0011 from '@/components/Book1/Text/Section0011'
 import BOOK1TEXTSECTION0012 from '@/components/Book1/Text/Section0012'
 import BOOK1TEXTSECTION0013 from '@/components/Book1/Text/Section0013'
 import BOOK1TEXTSECTION0014 from '@/components/Book1/Text/Section0014'
 import BOOK1TEXTSECTION0015 from '@/components/Book1/Text/Section0015'
 import BOOK1TEXTSECTION0016 from '@/components/Book1/Text/Section0016'
 import BOOK1TEXTSECTION0017 from '@/components/Book1/Text/Section0017'
 import BOOK1TEXTSECTION0018 from '@/components/Book1/Text/Section0018'
 import BOOK1TEXTSECTION0019 from '@/components/Book1/Text/Section0019'
 import BOOK1TEXTSECTION0020 from '@/components/Book1/Text/Section0020'
 import BOOK1TEXTSECTION0021 from '@/components/Book1/Text/Section0021'
 import BOOK1TEXTSECTION0022 from '@/components/Book1/Text/Section0022'
 import BOOK1TEXTSECTION0023 from '@/components/Book1/Text/Section0023'
 import BOOK1TEXTSECTION0024 from '@/components/Book1/Text/Section0024'
 import BOOK1TEXTSECTION0025 from '@/components/Book1/Text/Section0025'
 import BOOK1TEXTSECTION0026 from '@/components/Book1/Text/Section0026'
 import BOOK1TEXTSECTION0027 from '@/components/Book1/Text/Section0027'
 import BOOK1TEXTSECTION0028 from '@/components/Book1/Text/Section0028'
 import BOOK1TEXTSECTION0029 from '@/components/Book1/Text/Section0029'
 import BOOK1TEXTSECTION0030 from '@/components/Book1/Text/Section0030'
 import BOOK1TEXTSECTION0031 from '@/components/Book1/Text/Section0031'
 import BOOK1TEXTSECTION0032 from '@/components/Book1/Text/Section0032'
 import BOOK1TEXTSECTION0033 from '@/components/Book1/Text/Section0033'
 import BOOK1TEXTSECTION0034 from '@/components/Book1/Text/Section0034'
 import BOOK1TEXTSECTION0035 from '@/components/Book1/Text/Section0035'
 import BOOK1TEXTSECTION0036 from '@/components/Book1/Text/Section0036'
 import BOOK1TEXTSECTION0037 from '@/components/Book1/Text/Section0037'
 import BOOK1TEXTSECTION0038 from '@/components/Book1/Text/Section0038'
 import BOOK1TEXTSECTION0039 from '@/components/Book1/Text/Section0039'
 import BOOK1TEXTSECTION0040 from '@/components/Book1/Text/Section0040'
 import BOOK1TEXTSECTION0041 from '@/components/Book1/Text/Section0041'
 import BOOK1TEXTSECTION0042 from '@/components/Book1/Text/Section0042'
 import BOOK1TEXTSECTION0043 from '@/components/Book1/Text/Section0043'
 import BOOK1TEXTSECTION0044 from '@/components/Book1/Text/Section0044'
 import BOOK1TEXTSECTION0045 from '@/components/Book1/Text/Section0045'
 import BOOK1TEXTSECTION0046 from '@/components/Book1/Text/Section0046'
 import BOOK1TEXTSECTION0047 from '@/components/Book1/Text/Section0047'
 import BOOK1TEXTSECTION0048 from '@/components/Book1/Text/Section0048'
 import BOOK1TEXTSECTION0049 from '@/components/Book1/Text/Section0049'
 import BOOK1TEXTSECTION0050 from '@/components/Book1/Text/Section0050'
 import BOOK1TEXTSECTION0051 from '@/components/Book1/Text/Section0051'
 import BOOK1TEXTSECTION0052 from '@/components/Book1/Text/Section0052'
 import BOOK1TEXTSECTION0053 from '@/components/Book1/Text/Section0053'
 import BOOK1TEXTSECTION0054 from '@/components/Book1/Text/Section0054'
 import BOOK1TEXTSECTION0055 from '@/components/Book1/Text/Section0055'
 import BOOK1TEXTSECTION0056 from '@/components/Book1/Text/Section0056'
 import BOOK1TEXTSECTION0057 from '@/components/Book1/Text/Section0057'
 import BOOK1TEXTSECTION0058 from '@/components/Book1/Text/Section0058'
 import BOOK1TEXTSECTION0059 from '@/components/Book1/Text/Section0059'
 import BOOK1TEXTSECTION0060 from '@/components/Book1/Text/Section0060'
 import BOOK1TEXTSECTION0061 from '@/components/Book1/Text/Section0061'
 import BOOK1TEXTSECTION0062 from '@/components/Book1/Text/Section0062'
 import BOOK1TEXTSECTION0063 from '@/components/Book1/Text/Section0063'
 import BOOK1TEXTSECTION0064 from '@/components/Book1/Text/Section0064'
 import BOOK1TEXTSECTION0065 from '@/components/Book1/Text/Section0065'
 import BOOK1TEXTSECTION0066 from '@/components/Book1/Text/Section0066'
 import BOOK1TEXTSECTION0067 from '@/components/Book1/Text/Section0067'
 import BOOK1TEXTSECTION0068 from '@/components/Book1/Text/Section0068'
 import BOOK1TEXTSECTION0069 from '@/components/Book1/Text/Section0069'
 import BOOK1TEXTSECTION0070 from '@/components/Book1/Text/Section0070'
 import BOOK1TEXTSECTION0071 from '@/components/Book1/Text/Section0071'
 import BOOK1TEXTACKNOWLEDGMENTS from '@/components/Book1/Text/acknowledgments'
 import BOOK1TEXTFACT from '@/components/Book1/Text/fact'
 import BOOK2COVERPAGE from '@/components/Book2/coverpage'
 import BOOK2TITLE from '@/components/Book2/Title'
 import BOOK2DEDICATION from '@/components/Book2/Dedication'
 import BOOK2AUTHORS_NOTE from '@/components/Book2/Authors_Note'
 import BOOK2EPIGRAPH from '@/components/Book2/Epigraph'
 import BOOK2CH01 from '@/components/Book2/ch01'
 import BOOK2CH02 from '@/components/Book2/ch02'
 import BOOK2CH03 from '@/components/Book2/ch03'
 import BOOK2CH04 from '@/components/Book2/ch04'
 import BOOK2CH05 from '@/components/Book2/ch05'
 import BOOK2CH06 from '@/components/Book2/ch06'
 import BOOK2CH07 from '@/components/Book2/ch07'
 import BOOK2CH08 from '@/components/Book2/ch08'
 import BOOK2CH09 from '@/components/Book2/ch09'
 import BOOK2CH10 from '@/components/Book2/ch10'
 import BOOK2CH11 from '@/components/Book2/ch11'
 import BOOK2CH12 from '@/components/Book2/ch12'
 import BOOK2CH13 from '@/components/Book2/ch13'
 import BOOK2CH14 from '@/components/Book2/ch14'
 import BOOK2CH15 from '@/components/Book2/ch15'
 import BOOK2CH16 from '@/components/Book2/ch16'
 import BOOK2CH17 from '@/components/Book2/ch17'
 import BOOK2CH18 from '@/components/Book2/ch18'
 import BOOK2CH19 from '@/components/Book2/ch19'
 import BOOK2CH20 from '@/components/Book2/ch20'
 import BOOK2CH21 from '@/components/Book2/ch21'
 import BOOK2CH22 from '@/components/Book2/ch22'
 import BOOK2CH23 from '@/components/Book2/ch23'
 import BOOK2CH24 from '@/components/Book2/ch24'
 import BOOK2CH25 from '@/components/Book2/ch25'
 import BOOK2CH26 from '@/components/Book2/ch26'
 import BOOK2CH27 from '@/components/Book2/ch27'
 import BOOK2CH28 from '@/components/Book2/ch28'
 import BOOK2CH29 from '@/components/Book2/ch29'
 import BOOK2CH30 from '@/components/Book2/ch30'
 import BOOK2CH31 from '@/components/Book2/ch31'
 import BOOK2CH32 from '@/components/Book2/ch32'
 import BOOK2CH33 from '@/components/Book2/ch33'
 import BOOK2CH34 from '@/components/Book2/ch34'
 import BOOK2CH35 from '@/components/Book2/ch35'
 import BOOK2CH36 from '@/components/Book2/ch36'
 import BOOK2CH37 from '@/components/Book2/ch37'
 import BOOK2CH38 from '@/components/Book2/ch38'
 import BOOK2CH39 from '@/components/Book2/ch39'
 import BOOK2CH40 from '@/components/Book2/ch40'
 import BOOK2CH41 from '@/components/Book2/ch41'
 import BOOK2CH42 from '@/components/Book2/ch42'
 import BOOK2CH43 from '@/components/Book2/ch43'
 import BOOK2CH44 from '@/components/Book2/ch44'
 import BOOK2CH45 from '@/components/Book2/ch45'
 import BOOK2CH46 from '@/components/Book2/ch46'
 import BOOK2CH47 from '@/components/Book2/ch47'
 import BOOK2CH48 from '@/components/Book2/ch48'
 import BOOK2CH49 from '@/components/Book2/ch49'
 import BOOK2CH50 from '@/components/Book2/ch50'
 import BOOK2CH51 from '@/components/Book2/ch51'
 import BOOK2CH52 from '@/components/Book2/ch52'
 import BOOK2CH53 from '@/components/Book2/ch53'
 import BOOK2CH54 from '@/components/Book2/ch54'
 import BOOK2CH55 from '@/components/Book2/ch55'
 import BOOK2CH56 from '@/components/Book2/ch56'
 import BOOK2CH57 from '@/components/Book2/ch57'
 import BOOK2CH58 from '@/components/Book2/ch58'
 import BOOK2CH59 from '@/components/Book2/ch59'
 import BOOK2CH60 from '@/components/Book2/ch60'
 import BOOK2CH61 from '@/components/Book2/ch61'
 import BOOK2CH62 from '@/components/Book2/ch62'
 import BOOK2CH63 from '@/components/Book2/ch63'
 import BOOK2CH64 from '@/components/Book2/ch64'
 import BOOK2CH65 from '@/components/Book2/ch65'
 import BOOK2CH66 from '@/components/Book2/ch66'
 import BOOK2CH67 from '@/components/Book2/ch67'
 import BOOK2CH68 from '@/components/Book2/ch68'
 import BOOK2CH69 from '@/components/Book2/ch69'
 import BOOK2CH70 from '@/components/Book2/ch70'
 import BOOK2CH71 from '@/components/Book2/ch71'
 import BOOK2CH72 from '@/components/Book2/ch72'
 import BOOK2CH73 from '@/components/Book2/ch73'
 import BOOK2CH74 from '@/components/Book2/ch74'
 import BOOK2CH75 from '@/components/Book2/ch75'
 import BOOK2CH76 from '@/components/Book2/ch76'
 import BOOK2CH77 from '@/components/Book2/ch77'
 import BOOK2CH78 from '@/components/Book2/ch78'
 import BOOK2CH79 from '@/components/Book2/ch79'
 import BOOK2CH80 from '@/components/Book2/ch80'
 import BOOK2CH81 from '@/components/Book2/ch81'
 import BOOK2CH82 from '@/components/Book2/ch82'
 import COMONLOVE_2 from '@/components/Comon/love_2'
 import BOOK2ACKNOWLEDGMENTS from '@/components/Book2/Acknowledgments'
 import BOOK2THE_WORKS_OF_ALAN_JACOBSON from '@/components/Book2/The_Works_of_Alan_Jacobson'
 import BOOK2ACRONYMS from '@/components/Book2/Acronyms'
 import BOOK1TEXTTEASER00 from '@/components/Book1/Text/teaser00'
 import BOOK1TEXTTEASER01COVER from '@/components/Book1/Text/teaser01-cover'
 import BOOK1TEXTTEASER02 from '@/components/Book1/Text/teaser02'
 import BOOK1TEXTTEASER03 from '@/components/Book1/Text/teaser03'
 import BOOK1TEXTTEASER04 from '@/components/Book1/Text/teaser04'
 import COMONABOUT from '@/components/Comon/about'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import COMONAUBA from '@/components/Comon/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/Text/cover",
 			"name" : "Book1/Text/cover",
 			"component" : BOOK1TEXTCOVER
 		},
 		{
 			"path" : "/Book1/Text/titlepage",
 			"name" : "Book1/Text/titlepage",
 			"component" : BOOK1TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Book1/Text/dedication",
 			"name" : "Book1/Text/dedication",
 			"component" : BOOK1TEXTDEDICATION
 		},
 		{
 			"path" : "/Book1/Text/authornote",
 			"name" : "Book1/Text/authornote",
 			"component" : BOOK1TEXTAUTHORNOTE
 		},
 		{
 			"path" : "/Book1/Text/quotes",
 			"name" : "Book1/Text/quotes",
 			"component" : BOOK1TEXTQUOTES
 		},
 		{
 			"path" : "/Book1/Text/Section0001",
 			"name" : "Book1/Text/Section0001",
 			"component" : BOOK1TEXTSECTION0001
 		},
 		{
 			"path" : "/Book1/Text/Section0002",
 			"name" : "Book1/Text/Section0002",
 			"component" : BOOK1TEXTSECTION0002
 		},
 		{
 			"path" : "/Book1/Text/Section0003",
 			"name" : "Book1/Text/Section0003",
 			"component" : BOOK1TEXTSECTION0003
 		},
 		{
 			"path" : "/Book1/Text/Section0004",
 			"name" : "Book1/Text/Section0004",
 			"component" : BOOK1TEXTSECTION0004
 		},
 		{
 			"path" : "/Book1/Text/Section0005",
 			"name" : "Book1/Text/Section0005",
 			"component" : BOOK1TEXTSECTION0005
 		},
 		{
 			"path" : "/Book1/Text/Section0006",
 			"name" : "Book1/Text/Section0006",
 			"component" : BOOK1TEXTSECTION0006
 		},
 		{
 			"path" : "/Book1/Text/Section0007",
 			"name" : "Book1/Text/Section0007",
 			"component" : BOOK1TEXTSECTION0007
 		},
 		{
 			"path" : "/Book1/Text/Section0008",
 			"name" : "Book1/Text/Section0008",
 			"component" : BOOK1TEXTSECTION0008
 		},
 		{
 			"path" : "/Book1/Text/Section0009",
 			"name" : "Book1/Text/Section0009",
 			"component" : BOOK1TEXTSECTION0009
 		},
 		{
 			"path" : "/Book1/Text/Section0010",
 			"name" : "Book1/Text/Section0010",
 			"component" : BOOK1TEXTSECTION0010
 		},
 		{
 			"path" : "/Book1/Text/Section0011",
 			"name" : "Book1/Text/Section0011",
 			"component" : BOOK1TEXTSECTION0011
 		},
 		{
 			"path" : "/Book1/Text/Section0012",
 			"name" : "Book1/Text/Section0012",
 			"component" : BOOK1TEXTSECTION0012
 		},
 		{
 			"path" : "/Book1/Text/Section0013",
 			"name" : "Book1/Text/Section0013",
 			"component" : BOOK1TEXTSECTION0013
 		},
 		{
 			"path" : "/Book1/Text/Section0014",
 			"name" : "Book1/Text/Section0014",
 			"component" : BOOK1TEXTSECTION0014
 		},
 		{
 			"path" : "/Book1/Text/Section0015",
 			"name" : "Book1/Text/Section0015",
 			"component" : BOOK1TEXTSECTION0015
 		},
 		{
 			"path" : "/Book1/Text/Section0016",
 			"name" : "Book1/Text/Section0016",
 			"component" : BOOK1TEXTSECTION0016
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js